import { type Meta } from '../types/docs';

const META: Meta = {
  // renamed from item_added_to_collection, 2026-08-17 (param names unchanged)
  description: 'User added items to a showcase',
  name: 'item_added_to_showcase',
  params: [
    {
      description: 'Number of assets added in this action',
      name: 'asset_count',
      required: true,
      type: 'number',
    },
    {
      description: 'Number of boards added in this action',
      name: 'board_count',
      required: true,
      type: 'number',
    },
    {
      description:
        'Number of files added in this action. Absent on surfaces that only know item ids — files travel inside assetIds on the wire, so they cannot be split out there and are counted in asset_count instead',
      name: 'file_count',
      required: false,
      type: 'number',
    },
  ],
};

export default META;
